<template>
	<section class="pda-default">
		<div v-if="image == null">
			<div class="mdc-top-app-bar__row shadow">
				<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start t-color-red3">
					<span class="material-icons blue0006 mdc-top-app-bar__navigation-icon"
						@click="$router.go(-1)" @keypress="$router.go(-1)" tabindex="0"
					>
						arrow_back
					</span>
				</section>
				<section class="mdc-top-app-bar__section title">
					<div class="mdc-top-app-bar__title">{{ $t('1336') }}</div>
				</section>
				<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end t-color-red3">
					<a class="material-icons blue0006 mdc-top-app-bar__navigation-icon"></a>
				</section>
			</div>
			<div id="tab1" class="t-color-gray2  ripple-item">
					<div class="t-color-title t-headline9 l-spacing6 pdl-16 pdr-16 pdt-16 pdb-16 font-r">등록하기</div>
					<div class="t-color-content1 t-body3 pdl-16 pdr-16 pdb-16 l-spacing42 font-r">
							본 직책에는 다음의 자격증을 등록해야 합니다. 해당 자격증
							의 발급일과 만료일을 입력하세요.
					</div>
					<div class="t-color-content1 t-body3 pdt-8 pdl-16 pdr-16  l-spacing42 font-r">
							자격증
					</div>
					<div class="t-color-title t-subtitle3 pdt-2 pdl-16 pdr-16  l-spacing48 font-r">
							건강진단결과서 (보건증)
					</div>
					<div class="mgt-24 position-relative scanBase d-flex justify-content-center align-items-center">
							<div class="scanArea">
									<div class="top-left position-absolute"></div>
									<div class="top-right position-absolute"></div>
									<img :src="licenseData.licenseMember.file.resourceUri ? licenseData.licenseMember.file.resourceUri : require('@/images/thumnail.png')" alt=""
											v-if="!cropperVisible"
											@click="showFileChooser()" @keypress="showFileChooser()" tabindex="0"
											class="w-full"
									>
									<vue-cropper
											ref="cropper"
											:src="cropImg"
											alt="Source Image"
											:cropmove="cropImage"
											:autoCropArea="1"
											v-if="cropperVisible"
											class="cropper"
									>
									</vue-cropper>
									<div class="bottom-left position-absolute"></div>
									<div class="bottom-right position-absolute"></div>
							</div>
							<input
									ref="input"
									type="file"
									name="image"
									accept="image/*"
									@change="setImage"
									class="d-none"
							/>
					</div>
			</div>
			<div id="tab1" class="t-color-gray2 pdl-16 pdr-16 pdt-16 pdb-32">
				<div class="fixed-bottom pdl-8 pdr-8">
					<a @click="saveImage()" @keypress="saveImage()" tabindex="0" class="t-center d-block btn-red pdt-11 pdb-11 pdl-16 t-color-white b-radius4 mgb-32 b-shadow2 t-body2 shadow-bottom l-spacing98">
						{{ $t('1337') }}
					</a>
				</div>
			</div>
		</div>
		<AddLicense v-if="image != null" :image="image"/>
	</section>
</template>

<script>
// Components/Mixin/Extend/API define
import httpService from "@/api/httpService.js";
import licenseApi from "@/api/licenseApi.js";
import memberApi from "@/api/memberApi.js";
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import { log } from 'util';
import AddLicense from './AddLicense.vue';

export default {
		components: {
				VueCropper,
				AddLicense
		},
		data() {
				return {
						memberId: null,
						licenseData : {
								licenseMember: {
										file: {
												resourceUri: null
										}
								}
						},
						cropImg: '',
						cropperVisible: false,
						image: null
				};
		},
		mounted() {
			memberApi
				.getMemberInfo()
				.then((response) => {
						this.memberId = response.data.data.id;

						let params = {
						memberId: this.memberId
						};
						this.getLicenseInfo(params);
				})
				.catch((err) => {
				console.log(err);
				});
		},
		methods: {
				getLicenseInfo(params) {

						this.cropImg = '';
						this.cropperVisible = false;

						licenseApi.getMemberLicenseDetails(params).then((response) => { 
								this.licenseData = response.data.data;
						}).catch((err) => {
								console.log(err);
						});
				},
				showFileChooser() {
						this.$refs.input.click();
				},
				setImage(e) {
						this.cropperVisible = true
						const file = e.target.files[0];
						if (file.type.indexOf('image/') === -1) {
								console.log("Not a image file");
								return;
						}
						if (typeof FileReader === 'function') {
								const reader = new FileReader();
								reader.onload = (event) => {
								this.imgSrc = event.target.result;
								// rebuild cropperjs with the updated source
								this.$refs.cropper.replace(event.target.result);
								};
								reader.readAsDataURL(file);
						} else {
								console.log('Sorry, FileReader API not supported');
						}
				},
				cropImage() {
						this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
				},
				dataURItoBlob(dataURI) {
						// convert base64/URLEncoded data component to raw binary data held in a string
						let byteString
						if (dataURI.split(',')[0].indexOf('base64') >= 0){
								byteString = atob(dataURI.split(',')[1])
						}else {
								byteString = unescape(dataURI.split(',')[1])
						}

						// separate out the mime component
						let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

						// write the bytes of the string to a typed array
						let ia = new Uint8Array(byteString.length);
						for (let i = 0; i < byteString.length; i++) {
								ia[i] = byteString.charCodeAt(i);
						}

						return new Blob([ia], {type:mimeString});
				},
				saveImage() {
						this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
						let blob = this.dataURItoBlob(this.cropImg);

						let formData = new FormData();
						formData.append('file', blob, 'license.png');

						httpService.upload(formData).then((response) => {
								this.image = response;
								console.log(response);

								localStorage.setItem('uploadedLicense', response.data.data[0].resourceUri);
								//this.$router.push('/licensePopulate');  
						})
						.catch((err) => {
							console.log(err);
						});
				}
		}
};
</script>

<style scoped>
	.shadow {
		-webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
			0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
		box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
			0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
	}

	.toggle-size {
		font-size: 2.5rem;
	}

	.link-color {
		color: var(--Mainbtn);
	}

	.border-bottom {
		border-bottom: 1px solid var(--Divider);
	}

	.active-checked {
		color: var(--HeadlineBlack);
	}
	.cursor-pointer {
		cursor: pointer;
	}
	.iconHolder {
		background: var(--Mainbtn);
		border-radius: 50%;
	}

	.t-color-red3{
		color: var(--Mainbtn)
	}
	.scanImage {
		width: 104px;
		height: 104px;
	}
</style>
